class InputTooltipController {
  constructor ($rootScope) {
    'ngInject'
    this.$rootScope = $rootScope

    $rootScope.$on('tooltip:open', () => {
      this.showTooltip = false
    })
  }

  toggleTooltip () {
    if (!this.showTooltip) this.$rootScope.$broadcast('tooltip:open')
    this.showTooltip = !this.showTooltip
  }
}

export default InputTooltipController



// WEBPACK FOOTER //
// ./src/app/common/input-tooltip/input-tooltip.controller.js